/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_Project_AsInputs */



/**
* | output |
* | --- |
* | "Save Project As..." |
*
* @param {Save_Project_AsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_project_as = /** @type {((inputs?: Save_Project_AsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_Project_AsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le projet sous...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt speichern unter...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva progetto con nome...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить проект как...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar proyecto como...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将项目另存为...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトに名前を付けて保存...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("के रूप में इस परियोजना को बचाओ...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar projeto como...")
	return /** @type {LocalizedString} */ ("Save Project As...")
});